import React, { forwardRef } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../../../../common/constants';
import CommonCard from '../../../../../../components/CommonCard';
import RegisterFieldsTableList from './RegisterFieldsTableList';

const RegisterFieldsTable = forwardRef(
  (
    {
      tableHeaders,
      setTableHeaders,
      tableColumns,
      setTableColumns,
      isEditControl,
      isEditable,
      isDisabled,
      isProjectAdminOrInspector,
      showDetailPrompt,
      showTableFieldsPrompt,
      handleTableRouterPromptUpdate,
      searchValue,
      setSearchValue,
      selectedAggregates,
      setSelectedAggregates,
      fieldsData,
      onTableDirty,
      onTableSave,
      onTableErrorCheck,
      handleRegisterLogDetailRefetch,
      handleSaveAsDraft,
      showTableFieldConfirmModal,
      setShowTableFieldConfirmModal,
      historyData,
      registerId,
      showAll,
      showDeletedEntries,
      handleHisotryRefetch,
      registerLog,
    },
    ref,
  ) => {
    const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

    return (
      <>
        <CommonCard>
          <div className="width-percent-100">
            <div
              className={`${isDesktopViewport ? 'justify-between align-center' : 'flex-vertical'} d-flex mb-10`}
            >
              <h3 className="m-0">Table</h3>
              {!isEditControl && <div id="register-table-search" />}
            </div>
            <RegisterFieldsTableList
              ref={ref}
              tableHeaders={tableHeaders}
              setTableHeaders={setTableHeaders}
              tableColumns={tableColumns}
              setTableColumns={setTableColumns}
              isEditControl={isEditControl}
              isEditable={isEditable}
              isDisabled={isDisabled}
              isProjectAdminOrInspector={isProjectAdminOrInspector}
              showDetailPrompt={showDetailPrompt}
              showTableFieldsPrompt={showTableFieldsPrompt}
              handleTableRouterPromptUpdate={handleTableRouterPromptUpdate}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              fieldsData={fieldsData}
              onTableDirty={onTableDirty}
              onTableSave={onTableSave}
              onTableErrorCheck={onTableErrorCheck}
              selectedAggregates={selectedAggregates}
              setSelectedAggregates={setSelectedAggregates}
              handleRegisterLogDetailRefetch={handleRegisterLogDetailRefetch}
              handleSaveAsDraft={handleSaveAsDraft}
              showTableFieldConfirmModal={showTableFieldConfirmModal}
              setShowTableFieldConfirmModal={setShowTableFieldConfirmModal}
              historyData={historyData}
              registerId={registerId}
              showAll={showAll}
              showDeletedEntries={showDeletedEntries}
              handleHisotryRefetch={handleHisotryRefetch}
              registerLog={registerLog}
            />
          </div>
        </CommonCard>
      </>
    );
  },
);

export default RegisterFieldsTable;
